import __request__ from 'routing/request';
interface WorkspaceCreateInputRequest {
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly log_types: string[];
    readonly workspace_secret_path: string;
    readonly workspace_service_account_key: unknown;
    readonly name: string;
    readonly workspace_account_id: string;
    readonly workspace_client_id: string;
    readonly workspace_account_user: string;
    readonly polling_interval: number;
    readonly enable_throttling: boolean;
}
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
/**
 * Create a new Workspace input
 */
export function create(JSONbody: WorkspaceCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.googleworkspace.api.WorkspaceResource/googleworkspace/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
